import { LinkTo } from '@ember/routing';
import MessageBox from 'garaje/components/ui/classic/message-box';
import SettingsPanel from 'garaje/components/ui/classic/settings-panel';

<template>
  <SettingsPanel @isOpen={{true}} ...attributes as |sp|>
    {{#let sp.header sp.body as |PanelHeader PanelBody|}}
      <PanelHeader
        @iconUri="/assets/images/features/badge.svg"
        @title="ID scanning"
        @description="Require that visitors scan a valid, government-issued ID on the kiosk to come on-site. Note: this feature uses artificial intelligence to check the ID."
        @showCancel={{false}}
      >
        <button type="button" disabled class="btn btn--small btn--brand disabled" data-test-idscan-enable-button>
          Enable
        </button>
      </PanelHeader>
      <PanelBody as |PanelContent|>
        <PanelContent @style="inset">
          <MessageBox @type="warning" @header="App update required" class="mt-4">
            <p class="mb-0">
              Version 3.0.7 or higher of the Envoy Visitors iPad app is required.
              <LinkTo @route="visitors.devices.ipads">Manage iPads →</LinkTo>
            </p>
          </MessageBox>
        </PanelContent>
      </PanelBody>
    {{/let}}
  </SettingsPanel>
</template>
